import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TabForm } from 'src/app/models/forms/tab-form';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  tabs: FormGroup[] = [];

  constructor(private ds: DataService) { }

  ngOnInit() {

    this.ds.GetUser().subscribe(obs => {
      this.ds.GetTabs()
      .subscribe(n => {
        n.forEach(x => {
          const fb: FormBuilder = new FormBuilder();

          this.tabs.push(fb.group(new TabForm(x)));
        });
      });
    });
  }

}
